var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import MuiTextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core/styles';
import InputAdornment from '@material-ui/core/InputAdornment';
import { FiCheck } from 'react-icons/fi';
import Grow from '@material-ui/core/Grow';
import * as R from 'ramda';
export var CssTextField = withStyles(function (theme) { return ({
    root: {
        '& .MuiInput-underline:after': {
            borderBottomColor: 'default',
        },
        '& .MuiOutlinedInput-root': {
            borderRadius: 6,
            '&:hover fieldset': {
                borderColor: theme.palette.primary.main,
            },
        },
    },
}); })(MuiTextField);
export var SelectEndAdornment = function (_a) {
    var endAdornment = _a.endAdornment, error = _a.error, value = _a.value;
    switch (endAdornment) {
        case 'validation': {
            if (error || R.isNil(value) || R.isEmpty(value)) {
                return React.createElement(React.Fragment, null);
            }
            return (React.createElement(Grow, { in: !error, timeout: 500 },
                React.createElement(InputAdornment, { position: 'end' },
                    React.createElement(FiCheck, { color: "primary", size: 12 }))));
        }
        default:
            return React.createElement(React.Fragment, null);
    }
};
var TextField = function (_a) {
    var placeholder = _a.placeholder, InputProps = _a.InputProps, value = _a.value, error = _a.error, endAdornment = _a.endAdornment, props = __rest(_a, ["placeholder", "InputProps", "value", "error", "endAdornment"]);
    return (React.createElement(CssTextField, __assign({}, props, { value: value, error: error, placeholder: placeholder, InputProps: (!R.isEmpty(InputProps) && InputProps) || {
            endAdornment: React.createElement(SelectEndAdornment, { endAdornment: endAdornment, value: value, error: error }),
        } })));
};
TextField.defaultProps = {
    autoFocus: false,
    color: 'primary',
    disabled: false,
    error: false,
    endAdornment: 'disabled',
    fullWidth: false,
    multiline: false,
    placeholder: '',
    required: false,
    variant: 'outlined',
};
export default TextField;
//# sourceMappingURL=TextField.js.map